module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-7-a4bdde42dd3235a8c57be6b7852b5c6f.jpg";